import { Box, Grid, SxProps, Theme } from "@mui/material";
import HomeHero from "./components/HomeHero";
import FeatureCard from "./components/FeatureCard";
import { observer } from "mobx-react-lite";
import { ActivityTypes } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { featureFlagsStorage } from "e.sic-platform.webclient/src/services/feature-flags/FeatureFlagsStorage";
import { Flags } from "e.sic-platform.webclient/src/generated/FeatureFlags";

// Each service card is shown only when its feature flag is enabled (same pattern
// as the left menu in MenuStorageService). Add/remove a service by editing this list.
type ServiceCard = {
  flag: Flags;
  title: string;
  description: string;
  image: string;
  route: string;
  activities: ActivityTypes[];
  showSamples?: boolean;
  brandFontSx?: SxProps<Theme>;
};

const serviceCards: ServiceCard[] = [
  {
    flag: Flags.Enable_Ocr,
    title: "general.apps.ocr-service.title",
    description: "general.home.smartApp.description",
    image: "/images/sarida-smartapp.png",
    route: "/inspection-insights",
    activities: [ActivityTypes.VideoOcr],
    showSamples: true,
    // Match the "sarida™ SmartApps" hero wordmark: drop the serif/italic so the
    // wordmark uses the app's default theme font (non-italic, normal weight).
    brandFontSx: { fontStyle: "normal", fontWeight: 400 },
  },
  {
    flag: Flags.Enable_Ocr_Analysis,
    title: "general.apps.analysis-and-ocr.title",
    description: "general.apps.analysis-and-ocr.description",
    image: "/images/analysis-and-ocr.png",
    route: "/analysis-and-inspection-insights",
    activities: [ActivityTypes.VideoAnalysis, ActivityTypes.VideoOcr],
  },
  {
    flag: Flags.Enable_Analysis_And_Segmentation,
    title: "general.apps.analysis-and-segmentation.title",
    description: "general.apps.analysis-and-segmentation.description",
    image: "/images/analysis-and-segmentation.png",
    route: "/analysis-and-segmentation",
    activities: [ActivityTypes.VideoAnalysis, ActivityTypes.HighlightDetection],
  },
  {
    flag: Flags.Enable_Video_Analysis,
    title: "general.apps.video-analysis.title",
    description: "general.apps.video-analysis.description",
    image: "/images/video-analysis.png",
    route: "/video-analysis",
    activities: [ActivityTypes.VideoAnalysis],
  },
  {
    flag: Flags.Enable_Video_Segmentation,
    title: "general.apps.video-segmentation.title",
    description: "general.apps.video-segmentation.description",
    image: "/images/video-segmentation.png",
    route: "/video-segmentation",
    activities: [ActivityTypes.HighlightDetection],
  },
  {
    flag: Flags.Enable_Video_Conversion,
    title: "general.apps.video-conversion.title",
    description: "general.apps.video-conversion.description",
    image: "/images/video-conversion.png",
    route: "/video-conversion",
    activities: [ActivityTypes.VideoConversion],
  },
];

export default observer(function HomePage() {
  return (
    <Box sx={{ overflowX: "clip", width: "100%", maxWidth: "100%" }}>
      <HomeHero />

      <Grid container spacing={3} sx={{ px: 4, pt: 2, pb: 4, justifyContent: "center" }}>
        {serviceCards
          .filter((card) => featureFlagsStorage.isFeatureEnabled(card.flag))
          .map((card) => (
            <FeatureCard
              key={card.route}
              title={card.title}
              description={card.description}
              image={card.image}
              route={card.route}
              activities={card.activities}
              showSamples={card.showSamples}
              brandFontSx={card.brandFontSx}
            />
          ))}
      </Grid>
    </Box>
  );
});
